module.exports = __webpack_public_path__ + "static/media/foto_brahma_04.f5d6c4f0.jpg";